import type { TOC } from '@ember/component/template-only';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';

interface RequestSentDialogSignature {
  Args: {
    closeRequestSentDialog: () => void;
  };
}

export default <template>
  <ModalDialog
    @containerClass="ember-modal-dialog--request-sent-dialog !w-[300px]"
    @overlayClassNames="ember-modal-overlay--fadeIn"
    @targetAttachment="center"
    @translucentOverlay={{true}}
    @onClose={{@closeRequestSentDialog}}
  >
    <div class="p-8">
      <div class="flex justify-center">
        <img src="/assets/images/envelope-icon.svg" alt="request sent letter graphic" />
      </div>
      <div class="w-full">
        <h3 class="my-2 text-center">Request sent</h3>
        <p class="text-center">We'll contact you soon!</p>
      </div>
    </div>
  </ModalDialog>
</template> satisfies TOC<RequestSentDialogSignature>;
